/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".test-document-container[_ngcontent-%COMP%]{height:330px;width:100%;margin-top:1rem}.test-document-container[_ngcontent-%COMP%]   app-document-viewer[_ngcontent-%COMP%]{height:inherit;width:inherit}"];
export { styles as styles };

